const InputField = ({
  onChange,
  value,
  classNames,
  disabled = false,
  placeholder,
  ...rest
}) => {
  return (
    <input
      type="text"
      name="source"
      className={`flex-1 modalInputs ${
        disabled && "!text-muted-foreground"
      } ${classNames}`}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder || "www.example.com"}
      {...rest}
    />
  );
};

export default InputField;
